module.exports = __webpack_public_path__ + "static/media/output-onlinegiftools.65566f82.gif";